/* eslint-disable */
import React from "react";
import { Routes, BrowserRouter, Route, Navigate } from "react-router-dom";

import LoginPage from "../Page/LoginPage";
import RegisterPage from "../Page/RegisterPage";
import DropdownPage from "../Page/DropdownPage";

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/dropdown" element={<DropdownPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;